const solarMap = () => ({
  sendErrorToSentry: null,
  map: null,
  loading: false,
  zoom: 0,
  minZoom: 5,
  numberOfInstallers: 0,
  filterInstallers: 'Commercial',
  locations: [],
  results: [],
  strapiApi: '',
  loaded: false,
  activeMarker: 0,

  mapIcon: null,
  mapActiveIcon: null,
  markerLayer: null,

  init: function () {
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => {
        if (!this.loaded) {
          this.init()
          this.loaded = true
        }
      })
    } else {
      this.strapiApi = this.$el.dataset.strapi
      import('../../helpers/sentry-helper').then((module) => {
        this.sendErrorToSentry = module.sendErrorToSentry
      })

      if (typeof L === 'undefined') {
        if (this.sendErrorToSentry) {
          this.sendErrorToSentry(new ReferenceError("Leaflet 'L' is not defined"), {
            culprit: '/solar-partners',
            filename: 'resources/js/alpine/pages/solar-partners.js',
            function: 'init',
            message: "Leaflet 'L' object was not found when solarMap tried to initialize it."
          })
        }
        return // Exit if L is not defined
      }

      let isMobile = L.Browser.mobile
      this.zoom = isMobile ? 14 : 12
      this.minZoom = isMobile ? 3 : 5

      // Setup map
      this.map = L.map(this.$el.querySelector('.leaf-map'), {
        gestureHandling: isMobile
      }).setView([-41.3745, 172.4663], 5)

      let tile = L.tileLayer(
        'https://tile.jawg.io/12e2a19f-50ba-49de-b94a-a7038dff76c5/{z}/{x}/{y}{r}.png?access-token=Ex0sy5gRLLvjNN4TcsqvVDEJCa4rUtD8e1aaRANDKhNMQjuWxYD6KjBY9et1R3hT',
        {
          maxZoom: this.zoom,
          minZoom: this.minZoom,
          attribution: '',
          maxBoundsViscosity: 1.0,
          priority: 0.1,
          useCache: true,
          crossOrigin: true,
          opacity: 100
        }
      )

      // let bounds = L.LatLngBounds(this.map.getBounds())
      // tile.seed(bounds, 5, 10)

      tile.addTo(this.map)

      this.map.setMaxBounds(this.map.getBounds())
      this.map.attributionControl.addAttribution(
        '<a href="https://www.jawg.io?utm_medium=map&utm_source=attribution" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org?utm_medium=map-attribution&utm_source=jawg" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors'
      )

      // Setup icons
      this.mapIcon = L.icon({
        iconUrl: '/images/icons/map-marker.png',
        iconAnchor: [19, 34]
      })

      this.mapActiveIcon = L.icon({
        iconUrl: '/images/icons/map-marker.png',
        iconAnchor: [19, 34]
      })

      this.markerLayer = L.markerClusterGroup({
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            className: 'cluster-icon',
            html: '<b>' + cluster.getChildCount() + '</b>',
            iconSize: [48, 48]
          })
        },
        showCoverageOnHover: false
      })
      this.map.addLayer(this.markerLayer)

      // Load data and bind events
      this.$watch('filterInstallers', () => {
        this.handleFilterChange()
      })
      this.handleFilterChange()

      this.handleResize()
      window.addEventListener('resize', () => {
        this.handleResize()
      })

      this.map.addEventListener('moveend', () => {
        this.searchInstallersInBounds()
      })

      this.map.addEventListener('zoomend', () => {
        this.searchInstallersInBounds()
      })

      this.map.addEventListener('zoomstart', () => {
        this.locations.forEach((location) => {
          if (location.marker) {
            location.marker.closePopup()
          }
        })
      })
    }
  },

  handleFilterChange() {
    this.fetchInstallers().then(() => this.searchInstallersInBounds())
  },

  handleResize() {
    if (this.$refs && this.$refs.listings && this.$refs.map) {
      this.$refs.listings.style.height = `${this.$refs.map.offsetHeight - 104}px`
    }
  },

  handleSearch() {
    const result = this.$event.detail
    const latlng = new L.LatLng(result[0], result[1])
    this.map.flyTo(latlng, this.zoom)
  },

  async fetchInstallers() {
    // Clear current installers
    if(this.locations && this.locations.length > 0){
      this.locations.forEach((location) => {
        this.map.removeLayer(location.marker)
        this.markerLayer.removeLayer(location.marker)
      })
    }
    this.locations = null
    this.results = null

    const shuffle = (array) =>
      [...Array(array.length)]
        .map((_el, i) => Math.floor(Math.random() * i))
        .reduce((a, rv, i) => ([a[i], a[rv]] = [a[rv], a[i]]) && a, array)

    // Load new data
    try {
      const response = await fetch(
        `${this.strapiApi}/installers/locations/${this.filterInstallers.toLowerCase()}`
      )
      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(
          `HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`
        )
      }
      const data = await response.json()
      this.locations = shuffle(data)
      this.locations.forEach((location) => this.addLocationMarker(location))
    } catch (error) {
      console.error('Error fetching installers:', error)
      if (this.sendErrorToSentry) {
        this.sendErrorToSentry(error, {
          culprit: '/solar-partners',
          function: 'fetchInstallers',
          strapiApi: this.strapiApi,
          filterInstallers: this.filterInstallers
        })
      }
      this.locations = []
      this.results = []
    }
  },

  addLocationMarker(location) {
    if (!location.marker) {
      location.marker = L.marker([location.latitude, location.longitude], {
        title: location.name,
        icon: this.mapIcon
      })

      location.marker.bindPopup(
        `<div class="solar-popup"><h4>${location.name}</h4><p>${location.phone}</p><p><a target="_blank" href="${location.website}">WEBSITE</a></p><p><a class="more" href="${location.slug}">MORE DETAILS</a></p></div>`,
        {
          maxWidth: 400
        }
      )

      location.marker.addEventListener('popupopen', () => {
        this.map.panTo(location.marker.getLatLng())

        location.marker.setIcon(this.mapActiveIcon)
        this.activeMarker = location.id

        if (!L.Browser.mobile) {
          const el = document.getElementById(`location-listing_${location.id}`)
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            })
          }
        }
      })

      location.marker.addEventListener('popupclose', () => {
        location.marker.setIcon(this.mapIcon)
        if (this.activeMarker === location.id) this.activeMarker = 0
      })

      this.markerLayer.addLayer(location.marker)
    }
  },

  get installerSearchList() {
    if (this.searchTerm.length === 0) {
      return []
    }
    if (this.locations && this.locations.length > 0) {
      const results = this.locations
        .filter((location) => location && location.name)
        .filter((location) => location.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
        .map((location) => [location.name, location.slug])

      // dispatch event to notify address autocomplete component
      const event = new CustomEvent('foundSolarPartners', {
        detail: { resultsCount: results.length }
      })
      document.dispatchEvent(event)

      // take the first 5 results
      const list = results.slice(0, 5)
      return list
    }

    return []
  },

  searchInstallersInBounds() {
    if (this.locations.length > 0) {
      const boundsToSearch = this.map.getBounds()
      this.results = this.locations.filter((location) =>
        boundsToSearch.contains(location.marker.getLatLng())
      )
      this.numberOfInstallers = this.results.length
    }
  }
})

document.addEventListener('alpine:init', () => {
  Alpine.data('solarMap', solarMap)
})
